// Soft viewer gate — the passphrase ships in the bundle, it is not a secret.
// It only stops the dashboard being casually browsable by URL.
export const VIEWER_PASSPHRASE = "aria2026";

export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || "https://supabase.ariacarehome.app";
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "";
